import styles from "./VerifiedStepCard.module.scss";

interface VerifiedStepCardProps {
	label: string;
}

export const VerifiedStepCard = ({ label }: VerifiedStepCardProps) => {
	return (
		<div className={styles.card}>
			<svg className={styles.icon} width="22" height="22" viewBox="0 0 22 22" fill="none">
				<circle cx="11" cy="11" r="11" fill="#2FBF2B" />
				<path
					d="M6.5 11.5L9.5 14.5L15.5 8.5"
					stroke="var(--app-base-white)"
					strokeWidth="2"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</svg>
			<span className={styles.label}>{label}</span>
		</div>
	);
};
